import React from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // ✅ Removed Navigation
import "swiper/css";
import "swiper/css/pagination";


function Daisy() {
    const images = [
        {
          src: "images/daisypre.jpg",
          title: "Modern Design",
          description: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
        },
        {
          src: "images/daisypre1.jpg",
          title: "Refrigerated Storage",
          description: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
        },
        {
          src: "images/daisypre2.jpg",
          title: "Easy Access",
          description: "Front glass with gas strut for easy access and cleaning of the display unit.",
        },
      ];
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">Daisy</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newdaisy.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Daisy</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Versatile and functional display units with all the options for food retail and food service.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">DAISY is a very complete and flexible solution to equip small and medium-sized stores. Chilled, heated and dry ambient display cases and semi-verticals are available in two widths, 100/91 cm, and two heights, 120/135 cm, in a wide array of sizes and options so that nothing remains unsold!.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Meat and Charcuterie <span className=' text-blue-400'>-1… +5 °C</span> (3M1)</p>

         <p className="text-xl lg:text-2xl opacity-90">Pastry, Sandwiches, Cold Dishes and Beverages<span className=' text-blue-400'>-1… +7 °C</span> (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90">Pastry, Sandwiches, Cold Dishes and Beverages (with refrigerated shelf)<span className=' text-blue-400'>-1… +10 °C </span> (3H1)</p>
       <p className="text-xl lg:text-2xl opacity-90">Pizza Preparation<span className=' text-blue-400'>-1… +7 °C</span>  (3M2)</p>
       <p className="text-xl lg:text-2xl opacity-90">Chocolates <span className=' text-blue-400'>+13… +15 °C</span> (3S)</p>
       <p className="text-xl lg:text-2xl opacity-90">Ice cream<span className='text-fuchsia-950'>-18… -10 °C </span> <span  className='text-gray-400'>(4G3)</span>  </p>
       <p className="text-xl lg:text-2xl opacity-90">Hot Food <span className='text-gray-500'>(ventilated, ventilated with humidity control)</span><span className='text-red-500'>+65 °C</span> </p>
       <p className="text-xl lg:text-2xl opacity-90">Bakery and Pastry<span className='text-gray-500'> dry ambient</span> </p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3">CO2 | Glycol |  R290</p>
         </div>
    
    {/* carosel */}
    <div className="w-full   mt-8">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        className=" overflow-hidden relative"
      >
        {images.map((item, index) => (
          <SwiperSlide key={index} className="flex flex-col items-center md:p-6 relative">
            <img src={item.src} alt={`Slide ${index + 1}`} className="w-full h-[650px] object-cover" />
     
          </SwiperSlide>
        ))}
      </Swiper>
      <div className=" max-w-7xl">
    <div className="p-4">
      <p className="text-gray-700 text-xl lg:text-4xl text-center "> From chilled to hot products<br/>
      the most complete solution for the Food Service and Retail sectors</p>
      <p className="text-gray-700 font-thin  text-xl lg:text-2xl text-center mt-4">The wide range of the DAISY, with serve-overs, pizza counters, semi-verticals... for chilled, frozen, non-refrigerated, or hot food products, it is possible to create complete sets with various options to effectively meet the needs of your business in diverse customer service and self-service contexts.</p>
    </div>
  </div>
     

      {/* Custom Styling for Dots on Image */}
      <style jsx>{`
        .swiper-pagination-bullet {
          background: white !important;
          opacity: 1;
        }
        .swiper-pagination-bullet-active {
          background: #ffff !important;
        }
        .swiper-pagination {
          bottom: 60px !important;
        }
      `}</style>
    </div>


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">More capacity and visibility for your products</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Specialist model with refrigerated shelves, available for serve-overs with two display levels (H=120 cm) or three display levels (H=135 cm), allowing you to maximize your shop space.
         This design provides up to 60% more refrigerated display area compared to conventional models.</div>
</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/newdaisycase.gif" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/newdaisycase.jpg" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl lg:text-4xl">Grab and Go so easy, always at hand!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Refrigerated semi-verticals are available with one or two shelves, featuring service doors or closed backs, suitable for all your packaged products.
    Additionally, heated models are available for your hot products, along with front door options for both models to enhance energy savings.</div>
</div>
             </div>
    
    {/* case 3 */}
    <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl lg:text-4xl">Incredible ice creams with a perfect presentation!</p>
    <div className='mt-6 text-xl lg:text-2xl font-thin text-gray-500'>Specialized model for displaying and serving ice cream, featuring gentle ventilation to promote even temperature distribution throughout the display. This ensures proper preservation of ice cream up to 8 cm above the cuvette.</div>
    <ul className="list-[square] list-outside text-gray-500 text-xl ">
        {[
            "Two temperature classes: Class 4L1 (-18... -15 °C) or Class 4G3 (-18... -10 °C).",
            "Dimensions for 12, 18 or 24 5 litre ice cream pans.",
            "Front glass with passive low energy consumption. anti-condensation system.",
            "Double-glazed end sides for greater energy efficiency.",
            "Solar thermometer, no batteries, no maintenance, no costs."
        ].map((item, index) => (
            <li key={index} className="md:text-xl font-thin opacity-90 mt-6">{item}</li>
        ))}
    </ul>
</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/daisycase1.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 4 */}
            <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
              
        {/* ✅ Image Wrapper */}
        <div className="w-full md:w-1/2">
        <img src="/images/daisycas2.jpg" className="max-w-full h-auto object-contain" />
      </div>
    
      <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl lg:text-4xl">Numerous advantages and options for a more complete takeaway</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Ventilated heated serve-overs, with or without humidity control, bain-marie, heated top, heated oven... the DAISY range of display cabinets offers many options for your hot products</div>
    <div className='mt-6 text-xl font-thin text-gray-500'>Heating technology that saves money and enhances shop efficiency.</div>
    <div className='mt-6 text-xl font-thin text-gray-500'>Delicious hot dishes and products that are sure to sell out!</div>
</div>
             </div>
         </div>
    
    {/* card & description */}
    <div className="flex flex-wrap gap-6 justify-center">
  {[
    {
      img: "images/daisycard.jpg",
      text: "Available in 91 or 100 cm wide and 120 or 135 cm high models.",
    },
    {
      img: "images/daisycard1.jpg",
      text: "Models with refrigerated understorage and independent temperature control for quick product replenishment.",
    },
    {
      img: "images/daisycard2.jpg",
      text: "Front glass with gas strut for easy access and cleaning of the display unit.",
    },
    {
      img: "images/daisycard3.gif",
      text: "Incorporated LED screens into the displays for a better shopping experience and promotion at the point of sale (optional extra).",
    },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>


     </div>
    
  
        </div>
      )
    }
    

export default Daisy